export const set_interval = (time_interval = 0) => {
  if(time_interval <= 0) return null;

  if(time_interval > 60){
    time_interval = `${time_interval/60}-hours`;
  }
  else if(time_interval === 60){
    time_interval = `${time_interval/60}-hour`;
  }
  else if((time_interval < 60) && time_interval > 1){
    time_interval = `${time_interval}-mins`;
  }
  else{
    time_interval = `${time_interval}-min`;
  }
  return time_interval;
};